import styled from 'styled-components';
import { ReactComponent as _EmptyIcon } from 'styles/icons/no-notification.svg';
import { normalize } from 'utils/styles';
import { color, typography } from 'styles/settings';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: ${normalize('150px')};
`;

export const EmptyIcon = styled(_EmptyIcon)``;

export const Label = styled.span`
  ${typography.font.regular};
  font-size: ${typography.size.md};
  color: ${color.neutral.plainBlack};
  margin-top: ${normalize('40px')};
  margin-bottom: ${normalize('30px')};
`;

export const BackToCellText = styled.span`
  cursor: pointer;
  ${typography.font.semiBold};
  font-size: ${typography.size.md};
  color: ${color.brand.gold};
`;
